define(
    'collections/admin_menu_links.collection',[
        'loader',
        'config',

        'models/admin_menu_link.model'
    ],
    function(Loader, Config, linkModel)
    {
        var _ = Loader._;

        var AdminMenuLinksCollection = Loader.Backbone.Collection.extend({
            model: linkModel
        });

        return AdminMenuLinksCollection;
    }
);
